<script>

  export default {
    props: {
      quoteList: {
        type: Array,
        default: () => []
      },
      saleList: {
        type: Array,
        default: () => []
      },
      purchaseList: {
        type: Array,
        default: () => []
      },
      invoiceList: {
        type: Array,
        default: () => []
      },
      enabledRows:{
        type: Array,
        default: () => ['quote','sale','invoice']
      },
      wrapperClasses:{
        type: String,
        default: '',
      },
    },
    data() {
      return {
        windowInnerWidth: 0,
        bindings: {
          'quote': {
            'draft': ['draft', 'sent'],
            'positive': ['accepted'],
            'negative': ['deleted', 'reverted', 'expired'],
          },
          'sale': {
            'draft': ['draft', 'sent', 'resend','accepted'],
            'positive': ['completed'],
            'negative': ['deleted', 'reverted', 'declined','cancelled'],
          },
          'invoice': {
            'draft': ['draft', 'sent','accepted'],
            'positive': ['completed'],
            'negative': ['deleted', 'returned','cancelled'],
          },
          'purchase': {
            'draft': ['draft', 'sent','accepted'],
            'positive': ['completed'],
            'negative': ['deleted','cancelled'],
          },
        },
      }
    },
    async mounted() {
      this.windowInnerWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowInnerWidth = window.innerWidth
      });
    },
    methods: {
      resolveName(item){
        switch (item) {
          case 'quote':{
            return 'Quotes';
          }
          case 'sale':{
            return 'Sale Orders';
          }
          case 'invoice':{
            return 'Invoices';
          }
          case 'purchase':{
            return 'Purchases';
          }
          default:{
            break;
          }
        }
      },
      countByType(item, type){
        const val = this[`${item}List`].filter(el => this.bindings[`${item}`][`${type}`].indexOf(el.status) !== -1);
        if (val.length > 1){
          return val.reduce((a,b,index) => index !== 1 ? a + b.count : a.count + b.count);
        } else if (val.length) {
          return val[0].count
        }
        return 0;
      },
      hideColumn(obj){
        if (obj && obj.innerWidth){
          if (this.windowInnerWidth <= obj.innerWidth){
            return true
          }
        }
        return false
      },
    },
  }
</script>

<template>
  <section :class="wrapperClasses">
    <section class="border-rounded-20 fl-columns bg-col-translucent-25">
      <div v-for="(item, index) in enabledRows" :key="`row-${index}`" class="bg-inherit">
        <section class="pd-x-20 f-h-60 fl-left-right al-v-center" :class="{ 'border-t-1 border-col-default': index !== 0 }">
          <span class="f-w-7r tw-text-gray-800">{{ resolveName(item) }}</span>
          <BaseStatusPill
            status="draft"
            :value="`${countByType(item, 'draft')} Draft`"
            :extra-classes="['tw-text-primaryDarkened tw-bg-white tw-bg-opacity-25',
                             `${hideColumn({ 'innerWidth': 620 }) ? 'd-none' : ''}`,
                             `${hideColumn({ 'innerWidth': 1000 }) && !hideColumn({ 'innerWidth': 767 }) ? 'd-none' : ''}`,
                             `${!hideColumn({ 'innerWidth': 1000 }) || hideColumn({ 'innerWidth': 767 }) ? 'mg-r-15' : ''}`,
            ].join(' ')"/>
          <BaseStatusPill
            status="active"
            :value="`${countByType(item, 'positive')} Completed`"
            extra-classes="tw-text-primaryDarkened tw-bg-white tw-bg-opacity-25 mg-r-15" />
          <BaseStatusPill
            status="cancelled"
            :value="`${countByType(item, 'negative')} Expired`"
            :extra-classes="['tw-text-primaryDarkened tw-bg-white tw-bg-opacity-25',
                             `${hideColumn({ 'innerWidth': 1455 }) ? 'd-none' : ''}`,
                             `${!hideColumn({ 'innerWidth': 1455 }) && hideColumn({ 'innerWidth': 1500 }) ? 'mg-r-5' : ''}`,
                             `${!hideColumn({ 'innerWidth': 1500 }) ? 'mg-r-40' : ''}`,
            ].join(' ')"/>
        </section>
      </div>
    </section>
  </section>
</template>
